export default __webpack_public_path__ + "static/media/logo.61003cec.svg";